import { Action, ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import {
  aggregationsReducer,
  CandidateAggregationsState,
} from './aggregations/aggregations.reducer';
import {
  applicationHistoryReducer,
  ApplicationHistoryState,
} from './application-history/application-history.reducer';
import {
  associationLabelReducer,
  AssociationLabelState,
} from './association-label/association-label.reducer';
import { associationsReducer, AssociationsState } from './associations/associations.reducer';
import { attachmentsReducer, AttachmentsState } from './attachments/attachments.reducer';
import { candidatesReducer, CandidatesState } from './candidates/candidates.reducer';
import { companiesReducer, CompaniesState } from './companies/companies.reducer';
import {
  emilaTemplatesReducer,
  EmailTemplatesState,
} from './email-templates/email-templates.reducer';
import { feedbackReducer, FeedbackState } from './feedback/feedback.reducer';
import {
  hiringManagerStatusReducer,
  HiringManagerStatusState,
} from './hiring-manager-status/hiring-manager-status.reducer';
import { jobBoardReducer } from './job-boards/job-board.reducer';
import { JobBoardState } from './job-boards/state';
import { jobsReducer, JobsState } from './jobs/jobs.reducer';
import { managersReducer, ManagerState } from './managers/managers.reducer';
import { notificationsReducer, NotificationsState } from './notifications/notifications.reducer';
import { referralReducer, ReferralState } from './referral/referral.reducer';
import { rolesReducer, RolesState } from './roles/roles.reducer';
import { usersReducer, UsersState } from './users/users.reducer';
import {
  sharedResourcesReducer,
  SharedResourcesState,
} from '@core/shared-resources/store/shared-resources.reducer';

export interface CollectionsState {
  aggregations: CandidateAggregationsState;
  applicationHistory: ApplicationHistoryState;
  associationLabel: AssociationLabelState;
  associations: AssociationsState;
  attachments: AttachmentsState;
  candidates: CandidatesState;
  companies: CompaniesState;
  feedback: FeedbackState;
  jobBoards: JobBoardState;
  jobs: JobsState;
  managers: ManagerState;
  notifications: NotificationsState;
  referral: ReferralState;
  roles: RolesState;
  users: UsersState;
  hiringManagerStatus: HiringManagerStatusState;
  emilaTemplates: EmailTemplatesState;
  sharedResources: SharedResourcesState;
}

export const reducers: ActionReducerMap<CollectionsState, Action> = {
  aggregations: aggregationsReducer,
  applicationHistory: applicationHistoryReducer,
  associationLabel: associationLabelReducer,
  associations: associationsReducer,
  attachments: attachmentsReducer,
  candidates: candidatesReducer,
  companies: companiesReducer,
  feedback: feedbackReducer,
  jobBoards: jobBoardReducer,
  jobs: jobsReducer,
  managers: managersReducer,
  notifications: notificationsReducer,
  referral: referralReducer,
  roles: rolesReducer,
  users: usersReducer,
  hiringManagerStatus: hiringManagerStatusReducer,
  emilaTemplates: emilaTemplatesReducer,
  sharedResources: sharedResourcesReducer,
};

export const getCollectionsState = createFeatureSelector<CollectionsState>('collections');
